namespace Matrix.Workflow {
    export class ClientFunctionInvocationColumns {
        static columnsKey = 'Workflow.ClientFunctionInvocation';
    }
}
